<a href="#" (click)="onClick($event)">{{ params.value }}</a>
<div class="spinner-container" *ngIf="processingFiles">
  <mat-spinner></mat-spinner>
</div>
